import { Box, Stack, Skeleton, useTheme } from "@mui/material";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

const LeadHeaderSkeleton = () => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
        border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        borderLeft: "none",
        borderBottom: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        overflow: "hidden",
      }}
    >
      {isMobile && (
        <Stack
          sx={{
            p: theme.nawy.spacing.md,
            maxWidth: "100vw",
            gap: theme.nawy.spacing.md,
          }}
        >
          {/* Mobile First Row - Tags with bottom border */}
          <Stack
            direction="row"
            spacing={theme.nawy.spacing.xs}
            flexWrap="wrap"
            gap={theme.nawy.spacing.xs}
            sx={{
              maxWidth: "100%",
              pb: theme.nawy.spacing.sm,
              borderBottom: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
            }}
          >
            <Skeleton variant="rectangular" width={60} height={24} />
            <Skeleton variant="rectangular" width={60} height={24} />
          </Stack>

          {/* Mobile Second Row - Status and Actions */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ maxWidth: "100%" }}
          >
            {/* Left - Status */}
            <Box sx={{ flex: 0, minWidth: 0 }}>
              <Skeleton variant="rectangular" width={80} height={24} />
            </Box>

            {/* Right - Actions */}
            <Box sx={{ flex: 0, flexShrink: 0 }}>
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default LeadHeaderSkeleton;
